const initialState = {
  domain: "DECODING",
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_SKILLSSTATUS_STATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
